import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Producto } from '../../../_models/producto';
import {ConfirmationService, Message, SelectItem, TreeNode} from 'primeng/api';
import { ListaItem } from '../../../_models/lista-item';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Location } from '@angular/common';
import { ListaService } from '../../../_services/lista.service';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../../_models/funcionalidad';
import {ProductoHojaEvaluacion} from '../../../_models/producto-hoja-evaluacion';
import {CuentaContableControlService} from '../../../_services/cuenta-contable-control.service';
import {ProductoHojaEvaluacionService} from '../../../_services/producto-hoja-evaluacion.service';
import {CuentaContableService} from '../../../_services/cuenta-contable.service';
import {CuentaContable} from '../../../_models/cuenta-contable';
import {forkJoin} from 'rxjs';

@Component( {
  selector: 'app-producto-hoja-evaluacion',
  templateUrl: 'producto-hoja-evaluacion.component.html'
} )

export class ProductoHojaEvaluacionComponent implements OnInit {

  @Input() producto: Producto;
  @Input() detalle: false;
  listaEvaluaciones: ProductoHojaEvaluacion[] = [];
  cargando = true;
  formCuentaControl: FormGroup;
  formSubmitted = false;
  guardando = false;
  loadingTable = false;
  columnas: any[];
  prodCuentaControlEditar: ProductoHojaEvaluacion;
  busqueda: string;
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  refrescar = {};
  tituloBoton = 'BTN_GUARDAR';
  cuentasContables: CuentaContable[] = [];
  treeProperties: TreeNode[] = [];
  nodeSelected: TreeNode[] = [];
  loadingTree = true;
  submitted = false;
  msg: Message;
  formularioActivos: FormGroup;

  constructor( private navService: NavService,
               private fb: FormBuilder,
               private location: Location,
               private confirmService: ConfirmationService,
               private lisService: ListaService,
               private ctaContableCtrlService: CuentaContableControlService,
               private prodHojaEvaluacionService: ProductoHojaEvaluacionService,
               private serCuentaContable: CuentaContableService,
               ) {
  }

  ngOnInit(): void {
    this.consultaCuentas();
    this.columnas = [
      { field: 'codigoHojaEvaluacion', header: this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_CODIGOHOJAEVALUACION' ), sort: false },
      { field: 'descripcionCuenta', header: this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_NOMBRE' ), sort: false },
      { field: 'cuentaContable', header: this.navService.buscarMensaje( 'CUENTACONTABLE.LBL_CODCUENTA' ), sort: false },
      { field: 'indicadorAplicaTitular', header: 'Titular', sort: false },
      { field: 'indicadorAplicaCodeudor', header: 'Codeudor', sort: false },
      { field: 'indicadorAplicaDeudorSolidario', header: 'Deudor solidario', sort: false },
     ];
    this.busqueda = this.navService.getSearch( 'producto-hoja-evaluacion.component' );

  }

  get f() {
    return this.formCuentaControl.controls;
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.confirmService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'producto-hoja-evaluacion',
        accept: () => {
          this.prodCuentaControlEditar = null;
          this.formCuentaControl.reset();
          this.formSubmitted = false;
          this.guardando = false;
        },
        reject: () => {
        }
      } );
    } else {
      // regresar al datatable de productos
    }
  }

  setBusqueda() {
    this.navService.setSearch( 'producto-hoja-evaluacion.component', this.busqueda );
  }

  private showMessage( titulo: string, mensaje: string, severity: string = 'info' ) {
    this.navService.setMesage( 0, {
      severity: severity, summary: this.navService.buscarMensaje( titulo ),
      detail: this.navService.buscarMensaje( mensaje ), key: 'producto-hoja-evaluacion'
    } );
  }



  consultaCuentas(){
    forkJoin(
      this.serCuentaContable.listadoHabilitados(),
      this.prodHojaEvaluacionService.listadoPorProducto(this.producto.idProducto)
    ).subscribe( ( [ cuantasContables, hojaEvaluacion ] ) => {
      this.formularioActivos = this.fb.group( { } );
      this.cuentasContables = [];
      this.cuentasContables = cuantasContables;
      this.listaEvaluaciones = [];
      this.listaEvaluaciones = hojaEvaluacion;
      this.treeProperties = [];
      this.cuentasContables.sort( function( a, b ) {
        return a.cuentaContableCrezcamos - b.cuentaContableCrezcamos;
      } );
      for ( let c of this.cuentasContables.filter( t => t.idCuentaContablePadre === null && t.indicadorHabilitado === true ) ) {
        c.nivelCuentaContable = 1;
        const producto = this.listaEvaluaciones.find(x => x.idCuentaContable === c.idCuentaContable && x.indicadorHabilitado);
        let chil: any;
        chil = chil = this.listaHijos(c);
        const node = {
          'label': c.descripcionCuenta,
          'data': c,
          'children': chil
        }
        this.treeProperties.push( node );
        if ( producto && producto.idProductoHojaEvaluacion ) {
          this.nodeSelected.push( node );
        }
      }
      hojaEvaluacion.map(ho => {
        if ( ho.indicadorHabilitado ) {
          this.formularioActivos.addControl('indicadorAplicaTitular' + ho.idCuentaContable,
            this.fb.control(ho.indicadorAplicaTitular ? ho.indicadorAplicaTitular : false, Validators.required));

          if (this.detalle) {
            this.formularioActivos.get('indicadorAplicaTitular' + ho.idCuentaContable)?.disable();
          }

          this.formularioActivos.addControl('indicadorAplicaCodeudor' + ho.idCuentaContable,
            this.fb.control(ho.indicadorAplicaCodeudor ? ho.indicadorAplicaCodeudor : false, Validators.required));

          if (this.detalle) {
            this.formularioActivos.get('indicadorAplicaCodeudor' + ho.idCuentaContable)?.disable();
          }

          this.formularioActivos.addControl('indicadorAplicaDeudorSolidario' + ho.idCuentaContable,
            this.fb.control(ho.indicadorAplicaDeudorSolidario ? ho.indicadorAplicaDeudorSolidario : false, Validators.required));

          if (this.detalle) {
            this.formularioActivos.get('indicadorAplicaDeudorSolidario' + ho.idCuentaContable)?.disable();
          }
        }
      });

      this.loadingTree = false;
      this.cargando = false;
    });

  }

  listaHijos(cuenta: any) : any[]{
    const hijos = this.cuentasContables.filter( x => x.idCuentaContablePadre ===
      cuenta.idCuentaContable);
    let valor = 0;
    let expandChils: any[] = [];
    let chil: any;
    hijos.forEach(te => {
      const producto = this.listaEvaluaciones.find(x => x.idCuentaContable === te.idCuentaContable && x.indicadorHabilitado);
      chil = this.listaHijos(te);
       const node = {
         'label': te.descripcionCuenta,
         'data': te,
         'children': chil,
       };
      expandChils.push( node );
      if ( producto && producto.idProductoHojaEvaluacion ) {
        this.nodeSelected.push( node );
      }
    });
    return expandChils;
  }


  nodeSelect(event) {
    if(event.node.children.length === 0){
      this.buscarPadres(event.node.data, true);
      this.loadingTable = false;
    } else {
      this.bucarHijos(event.node.data, true);
    }

  }

  nodeUnselect(event) {
    if(event.node.children.length === 0){
      this.buscarPadres(event.node.data, false);
      this.loadingTable = false;
    } else {
      this.bucarHijos(event.node.data, false);
    }
  }

  nodeExpand( node : any ) {
    let expandChils: any[] = [];
    let chil: any;
    chil = [ { 'label': 'NOAPLICA', } ];

    for ( let c of this.cuentasContables.filter( t => t.idCuentaContablePadre === node.data.idCuentaContable && t.indicadorHabilitado === true ) ) {
      expandChils.push( {
        'label': c.cuentaContableCrezcamos + ' ' + c.descripcionCuenta,
        'data': c,
        'parent': node,
        'children': chil
      } );
    }
    node.children = expandChils;
  }


  bucarHijos(cuenta: any, accion: boolean ) {
    const hijos = this.cuentasContables.filter( x => x.idCuentaContablePadre ===
      cuenta.idCuentaContable);
    hijos.forEach(te => {
      const subHijos = this.cuentasContables.filter( x => x.idCuentaContablePadre ===
        te.idCuentaContable);
      if ( subHijos.length > 0 ) {
        this.bucarHijos(te, accion);
      } else {
        this.buscarPadres(cuenta, accion);
      }
      this.buscarPadres(te, accion);
    });
  }

  buscarPadres(cuenta: any, accion: boolean ){
    let cuentaTemp = cuenta;
    do {
      const  padre = this.cuentasContables.find( x => x.idCuentaContable ===
        cuentaTemp.idCuentaContablePadre);
      let hojaEvaluacion  = {} as ProductoHojaEvaluacion;
      hojaEvaluacion.idProducto = this.producto.idProducto;
      hojaEvaluacion.idCuentaContable = cuentaTemp.idCuentaContable;
      hojaEvaluacion.descripcionCuenta = cuentaTemp.descripcionCuenta;
      hojaEvaluacion.codigoHojaEvaluacion = cuentaTemp.codigoHojaEvaluacion;
      hojaEvaluacion.cuentaContable = cuentaTemp.cuentaContable;
      hojaEvaluacion.idCuentaContablePadre = cuentaTemp.idCuentaContablePadre;
      hojaEvaluacion.indicadorHabilitado = true;
      hojaEvaluacion.indicadorAplicaTitular = true;
      hojaEvaluacion.indicadorAplicaCodeudor = false;
      hojaEvaluacion.indicadorAplicaDeudorSolidario = false;
      if ( accion ) {
        const estaCuenta = this.listaEvaluaciones.find( x => x.idCuentaContable ===
          cuentaTemp.idCuentaContable);
        this.formularioActivos.addControl('indicadorAplicaTitular' + hojaEvaluacion.idCuentaContable, this.fb.control(estaCuenta ? estaCuenta.indicadorAplicaTitular : true , Validators.required));
        this.formularioActivos.addControl('indicadorAplicaCodeudor' + hojaEvaluacion.idCuentaContable, this.fb.control(estaCuenta ? estaCuenta.indicadorAplicaCodeudor : false , Validators.required));
        this.formularioActivos.addControl('indicadorAplicaDeudorSolidario' + hojaEvaluacion.idCuentaContable, this.fb.control(estaCuenta ? estaCuenta.indicadorAplicaDeudorSolidario : false , Validators.required));
      }

      if (accion) {
        const estaCuenta = this.listaEvaluaciones.find( x => x.idCuentaContable ===
          cuentaTemp.idCuentaContable);
        if(estaCuenta){
          this.listaEvaluaciones.map( pr => {
            if(pr.idCuentaContable === estaCuenta.idCuentaContable){
              pr.indicadorHabilitado = true;
            }
          });
        } else {
          this.listaEvaluaciones.push(hojaEvaluacion);
        }
      } else {
        //Busqueda de hijos
        const subHijos = this.cuentasContables.filter( x => x.idCuentaContablePadre ===
          cuentaTemp.idCuentaContable);
        if ( subHijos.length === 0 ) {
          this.listaEvaluaciones.map( pr => {
            if ( pr.idCuentaContable === hojaEvaluacion.idCuentaContable){
              pr.indicadorHabilitado = false;
            }
          });
        } else {
          let estado = false;
          for( let s = 0 ; s < (subHijos.length ); s++) {
             let hijo = subHijos[s];
             let hoja = this.listaEvaluaciones.find( x => x.idCuentaContable === hijo.idCuentaContable);
             if(hoja && hoja.indicadorHabilitado){
               estado = true;
             }
          }
          this.listaEvaluaciones.map( pr => {
              if ( pr.idCuentaContable === hojaEvaluacion.idCuentaContable){
                pr.indicadorHabilitado = estado;
              }
          });
        }
      }
      cuentaTemp = padre;
    } while (cuentaTemp);
  }

  get getEvaluaciones() {
    this.listaEvaluaciones.sort( function( a, b ) {
      return a.codigoHojaEvaluacion - b.codigoHojaEvaluacion;
    } );
    return this.listaEvaluaciones.filter( s => s.indicadorHabilitado );
  }


  guardarHojaEvalaacion(){
    this.submitted = true;
    if ( this.listaEvaluaciones.length > 0 ) {
      this.guardando = true;
      this.cargando = true;
      const listaHojaEvaluaciones = this.listaEvaluaciones.filter( s => s.indicadorHabilitado );
      if ( listaHojaEvaluaciones.length > 0 ) {
        this.prodHojaEvaluacionService.bulk(this.listaEvaluaciones).subscribe( res => {
          this.navService.setMesage( 1 );
          this.guardando = false;
          this.submitted = false;
          this.cargando = false;
          this.consultaCuentas();

        } );
      } else {
        this.guardando = false;
        this.cargando = false;
        this.msg = {
          severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ) + '!',
          detail: this.navService.buscarMensaje( 'PRODUCTOCUENTACONTROL.LBL_ERRORLISTA' )
        };
        this.navService.setMesage( 4, this.msg );
      }
    } else {
      this.guardando = false;
      this.cargando = false;
      this.msg = {
        severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ) + '!',
        detail: this.navService.buscarMensaje( 'PRODUCTOCUENTACONTROL.LBL_ERRORLISTA' )
      };
      this.navService.setMesage( 4, this.msg );
    }
  }

  cancelarEdicion( dirty: boolean ) {
    if ( dirty ) {
      this.confirmService.confirm( {
        message: this.navService.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navService.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'producto-hoja-evaluacion',
        accept: () => {
          this.prodCuentaControlEditar = null;
          this.formCuentaControl.reset();
          this.formSubmitted = false;
          this.guardando = false;
          this.tituloBoton = 'BTN_GUARDAR';
          this.consultaCuentas();
        },
        reject: () => {
        }
      } );
    } else {
      this.prodCuentaControlEditar = null;
      this.formCuentaControl.reset();
      this.formSubmitted = false;
      this.guardando = false;
      this.tituloBoton = 'BTN_GUARDAR';
      this.consultaCuentas();
    }
  }


  validarIndicadores(indicador: string, cuenta: any, accion: boolean ) {
    if(!accion){
      let estadoTemp = true;
      switch ( indicador ) {
        case 'indicadorAplicaTitular': {
          if ( !cuenta.indicadorAplicaCodeudor && !cuenta.indicadorAplicaDeudorSolidario) {
            estadoTemp = false;
          }
          break;
        }
        case 'indicadorAplicaCodeudor': {
          if ( !cuenta.indicadorAplicaTitular && !cuenta.indicadorAplicaDeudorSolidario) {
            estadoTemp = false;
          }
          break;
        }
        case 'indicadorAplicaDeudorSolidario': {
          if ( !cuenta.indicadorAplicaTitular && !cuenta.indicadorAplicaCodeudor) {
            estadoTemp = false;
          }
          break;
        }
        default: {
          break;
        }
      }

      if(!estadoTemp) {
        const campoPadre = indicador + cuenta.idCuentaContable;
        this.act[campoPadre].setValue(true);
        this.msg = {
          severity: 'info', summary: this.navService.buscarMensaje( 'LBL_INFORMACION' ) + '!',
          detail: this.navService.buscarMensaje( 'PRODUCTOCUENTACONTROL.LBL_ERRORVINCULACION' )
        };
        this.navService.setMesage( 4, this.msg );
        return;
      }


    }


    const  cuentaSeleccionadad = this.cuentasContables.find( x => x.idCuentaContable === cuenta.idCuentaContable);
    const subHijos = this.cuentasContables.filter( x => x.idCuentaContablePadre ===
      cuentaSeleccionadad.idCuentaContable);
    if (subHijos.length > 0) {
      this.bucarHijosIndicador(indicador, cuentaSeleccionadad, accion);
    } else {
      this.buscarPadresIndicador(indicador, cuentaSeleccionadad, accion);
    }
  }

  bucarHijosIndicador(indicador: string, cuenta: any, accion: boolean) {
    const hijos = this.cuentasContables.filter( x => x.idCuentaContablePadre ===
      cuenta.idCuentaContable);
    hijos.forEach(te => {
      const subHijos = this.cuentasContables.filter( x => x.idCuentaContablePadre ===
        te.idCuentaContable);
      if ( subHijos.length > 0 ) {
        this.bucarHijosIndicador( indicador , te, accion);
      } else {
        this.buscarPadresIndicador(indicador, cuenta, accion);
      }
      this.buscarPadresIndicador(indicador, te , accion);
    });
  }

  buscarPadresIndicador(indicador: string, cuenta: any , accion: boolean){
    let cuentaTemp = cuenta;
    do {
      const  padre = this.cuentasContables.find( x => x.idCuentaContable === cuentaTemp.idCuentaContablePadre);
      const campo = indicador + cuentaTemp.idCuentaContable;
      //console.log(cuentaTemp.descripcionCuenta);
      const estaCuenta = this.listaEvaluaciones.find( x => x.idCuentaContable ===  cuentaTemp.idCuentaContable);
      if(estaCuenta && estaCuenta.indicadorHabilitado){
        let valor = accion;
        if (!valor) {
          const subHijos = this.cuentasContables.filter( x => x.idCuentaContablePadre ===
            cuentaTemp.idCuentaContable);
          if ( subHijos.length === 0 ) {
            this.listaEvaluaciones.map( pr => {
              if ( pr.idCuentaContable === cuentaTemp.idCuentaContable){
                valor = false;
              }
            });
          } else {
            for( let s = 0 ; s < (subHijos.length ); s++) {
              let hijo = subHijos[s];
              let hoja = this.listaEvaluaciones.find( x => x.idCuentaContable === hijo.idCuentaContable);
              if(hoja && hoja.indicadorHabilitado){
                if ( indicador === 'indicadorAplicaTitular' && hoja.indicadorAplicaTitular) {
                  valor = true;
                } else if ( indicador === 'indicadorAplicaDeudorSolidario' && hoja.indicadorAplicaDeudorSolidario ) {
                  valor = true;
                } else if ( indicador === 'indicadorAplicaCodeudor' && hoja.indicadorAplicaCodeudor) {
                  valor = true;
                }
              }
            }
          }
        }
        //console.log(valor);
        this.act[campo].setValue(valor);
        if ( cuentaTemp.idCuentaContablePadre ) {
          const campoPadre = indicador + cuentaTemp.idCuentaContablePadre;
          this.act[campoPadre].setValue(valor);
        }
        this.listaEvaluaciones.map( pr => {
          if ( pr.idCuentaContable === estaCuenta.idCuentaContable ) {
            if ( indicador === 'indicadorAplicaTitular' ) {
              pr.indicadorAplicaTitular = valor;
            } else if ( indicador === 'indicadorAplicaDeudorSolidario' ) {
              pr.indicadorAplicaDeudorSolidario = valor;
            } else if ( indicador === 'indicadorAplicaCodeudor' ) {
              pr.indicadorAplicaCodeudor = valor;
            }
          }
        });
      }
      cuentaTemp = padre;
    } while (cuentaTemp);
  }


  get act() {
    return this.formularioActivos.controls;
  }






}
